export const DEFAULT_PROFILE_PICTURE_URL = "https://i.imgur.com/tp4dxnx.png";
